module.exports = __webpack_public_path__ + "static/media/pool-scorer-main.6c5b0fce.png";